/**
 * Load Signalsmith Stretch UNTOUCHED, from public/vendor, never through webpack
 * (2026-09-26, found live the first time Anthony tapped the key control).
 *
 * The library builds its AudioWorklet by stringifying one of its own functions
 * and handing that text to the audio thread. Bundled, CRA's babel rewrote that
 * function, wrapping the processor class in a helper, `(0,D.A)(AudioWorklet
 * Processor)`, where D is a webpack module that does not exist in the worklet's
 * global scope. The worklet threw on load in every browser; the player caught
 * it and showed "Key change is not available in this browser". A test against
 * the package's own file passed, because that file was never transformed.
 *
 * So the vendored copy (byte-identical to node_modules, pinned by
 * keyShift.vendor.test.js) is imported natively, with webpackIgnore, and the
 * worklet source reaches the audio thread exactly as its authors wrote it.
 * Bump the file name with the version so a cached old copy cannot linger.
 */
export const STRETCH_URL = `${process.env.PUBLIC_URL || ''}/vendor/signalsmith-stretch-1.3.2.mjs`;

const loadStretch = () => import(/* webpackIgnore: true */ STRETCH_URL);

export default loadStretch;
